// @flow
import React, { PureComponent, Fragment } from 'react';
import { withHelmet } from 'infrastructure/seo/Helmet';

import RankingTable from 'components/fragments/RankingTable';
import RencontreClubs from 'components/fragments/rencontre/RencontreClubs';

import { formatFullDateString } from 'utils/dateUtils';
import { getMetaBySlug } from 'utils/seoUtils';

import type { RencontreSimpleType } from 'types/Rencontre';
import type { RencontreType } from 'types/Rencontre';
import type { RankingType } from 'types/Ranking';

export type StateProps = {
  ranking: RankingType[],
  lastRencontres: RencontreSimpleType[],
  rencontre: RencontreType,
  competitionLink: string,
  rencontreid: string
};

type Props = StateProps;

class RencontreGeneralSoon extends PureComponent<Props> {
  _renderRencontre = ({
    localStructure,
    visiteurStructure,
    resultLocal: { pointsDeMarque: pointLocal },
    resultVisiteur: { pointsDeMarque: pointVisiteur },
    competition: { nom: competitionNom },
    journee: { nom: journeeNom },
    dateEffective,
    id
  }: RencontreSimpleType) => {
    const { rencontreid } = this.props;
    const url = window.location.pathname.replace(rencontreid, id);
    return (
      <Fragment key={id}>
        <p className="block-competition__head ft-h6 ft-up mb-1">
          {`${competitionNom} - ${journeeNom} - ${formatFullDateString(dateEffective)}`}
        </p>
        <a href={url} className="match box box--white mb-2">
          <RencontreClubs
            localStructure={localStructure}
            visiteurStructure={visiteurStructure}
            pointLocal={pointLocal}
            pointVisiteur={pointVisiteur}
          />
        </a>
      </Fragment>
    );
  };

  _renderRencontres = () => {
    const { lastRencontres, competitionLink } = this.props;
    const lc = 'link-chevron';
    return (
      <div className="col col-lg-8on9">
        <h3 className="mb-3">Dernières rencontres</h3>
        {lastRencontres.map(rencontre => this._renderRencontre(rencontre))}
        <a
          href={competitionLink || 'https://monclubhouse.ffr.fr/'}
          target="_blank"
          rel="noopener noreferrer"
          className={`${lc} ${lc}--blue ${lc}--inline ${lc}--external ${lc}--desktop`}
        >
          <span>Voir les résultats de la compétition</span>
          <i className="icon icon-external" />
        </a>
      </div>
    );
  };

  render() {
    const { ranking, lastRencontres, rencontre, competitionLink } = this.props;
    const teamA = rencontre.localStructure.nom;
    const teamB = rencontre.visiteurStructure.nom;
    const saison = rencontre.dateEffective.getFullYear();
    const lc = 'link-chevron';

    if (!ranking && lastRencontres.length === 0) {
      return null;
    }

    return (
      <>
        {lastRencontres && lastRencontres.length > 0 && <div className="row mt-2">{this._renderRencontres()}</div>}
        <div className="row mt-5">
          <div className="col col-lg-8on9">
            <h2 className="mb-3 ranking__title">{`Avant match ${teamA} - ${teamB} saison ${saison}`}</h2>
            <h3 className="mb-3">Classement actuel</h3>
            <RankingTable classement={ranking} className="ranking ranking--opposition mb-3 mb-lg-0" />
            {ranking && (
              <a
                href={`${competitionLink}classements` || 'https://monclubhouse.ffr.fr/'}
                target="_blank"
                rel="noopener noreferrer"
                className={`${lc} ${lc}--blue ${lc}--inline ${lc}--external`}
              >
                <span>Voir le classement complet</span>
                <i className="icon icon-external" />
              </a>
            )}
            <hr className="separator mt-4 mt-lg-7" />
          </div>
        </div>
      </>
    );
  }
}

export default withHelmet(RencontreGeneralSoon)((Helmet, pageProps) => {
  const { rencontre } = pageProps;
  const teamA = rencontre.localStructure.nom;
  const teamB = rencontre.visiteurStructure.nom;

  const meta = getMetaBySlug('match/avant-match');

  return (
    <Helmet>
      <title>{meta.title(teamA, teamB)}</title>
      {meta.description() !== '' ? <meta name={'description'} content={meta.description()} /> : ''}
      <meta name={'keywords'} content={meta.keywords(teamA, teamB)} />
      <meta property={'og:title'} content={meta.title(teamA, teamB)} />
      {meta.description() !== '' ? <meta property={'og:description'} content={meta.description()} /> : ''}
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
